<template>
<v-card>
  <v-card-title class='subtitle' >
    Assign form
    <v-spacer></v-spacer>
    <v-btn @click="$emit('close')" icon >
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
  <request-status :request='request' />
  <v-card-text>
    <client-list
      show-list-initially
      @relationshipselected='setRelationship' ></client-list>
    <!-- <pre>{{payload}}</pre> -->
  </v-card-text>
  <v-card-actions>
    <v-spacer ></v-spacer>
    <v-btn @click='save' :loading='request.loading' color='primary' >Assign</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import ClientList from '@/components/client/ClientList'
import RequestStatus from '@/components/ui/RequestStatus'

export default {
  name: 'AssignForm',
  components: {ClientList, RequestStatus},
  props: {
    value: { type: Object, required: true },
    formId: { required: true }
  },
  data () {
    return {
      rel: {},
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/assign_submission'
      }
    }
  },
  computed: {
    payload () {
      return {
        form_id: this.formId,
        submission_id: this.value.id,
        relationship_id: this.rel.id
      }
    }
  },
  methods: {
    save () {
      this.request.data = this.payload
      this.$request('save', this.request)
    },
    setRelationship (rel) {
      this.rel = rel
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignForm.vue?6f86b8f7